function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 16,
  rx: 2,
  fill: "#4C86B7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0019 4.4585C12.194 4.4585 10.7311 5.92146 10.7311 7.72934C10.7311 8.52029 11.0106 9.24582 11.4804 9.81079H8.79237C9.26218 9.24582 9.54169 8.52029 9.54169 7.72934C9.54169 5.92146 8.07873 4.4585 6.27084 4.4585C4.46296 4.4585 3 5.92146 3 7.72934C3 9.53722 4.46296 11.0002 6.27084 11.0002H14.0019C15.8098 11.0002 17.2728 9.53722 17.2728 7.72934C17.2728 5.92146 15.8098 4.4585 14.0019 4.4585ZM6.27084 9.81079C5.12308 9.81079 4.1894 8.87711 4.1894 7.72934C4.1894 6.58157 5.12308 5.64789 6.27084 5.64789C7.41861 5.64789 8.35229 6.58157 8.35229 7.72934C8.35229 8.87711 7.41861 9.81079 6.27084 9.81079ZM14.0019 9.81079C12.8542 9.81079 11.9205 8.87711 11.9205 7.72934C11.9205 6.58157 12.8542 5.64789 14.0019 5.64789C15.1497 5.64789 16.0834 6.58157 16.0834 7.72934C16.0834 8.87711 15.1497 9.81079 14.0019 9.81079Z",
  fill: "white"
});

function SvgVoicemailBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemailBlue);
export default __webpack_public_path__ + "static/media/VoicemailBlue.7c703ab2.svg";
export { ForwardRef as ReactComponent };